import { render, staticRenderFns } from "./SmsMessageTab.vue?vue&type=template&id=243c2eef"
import script from "./SmsMessageTab.vue?vue&type=script&lang=js"
export * from "./SmsMessageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports